import StlViewer from "./StlViewer.jsx";
import GlbViewer from "./GlbViewer.jsx";

function isStlFormat(format, src) {
  if (format === "stl") return true;
  if (format && format !== "stl") return false;
  return /\.stl(?:\?|$)/i.test(String(src || ""));
}

export default function ModelViewer({
  src,
  format,
  alt = "Generated 3D model",
  className = "",
}) {
  if (!src) {
    return (
      <div
        className={`flex h-[420px] items-center justify-center rounded-xl border border-dashed border-white/15 bg-white/[0.02] text-sm text-white/45 ${className}`}
      >
        Your generated model preview will appear here.
      </div>
    );
  }

  if (isStlFormat(format, src)) {
    return <StlViewer src={src} className={className} />;
  }

  return <GlbViewer src={src} className={className} alt={alt} />;
}
